<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                d="M0.34375 10.5C0.34375 4.89086 4.89086 0.34375 10.5 0.34375C16.1091 0.34375 20.6562 4.89086 20.6562 10.5C20.6562 16.1091 16.1091 20.6562 10.5 20.6562C4.89086 20.6562 0.34375 16.1091 0.34375 10.5ZM14.2607 8.61034C14.5115 8.25924 14.4302 7.77131 14.0791 7.52052C13.728 7.26973 13.2401 7.35105 12.9893 7.70216L9.61906 12.4205L7.92743 10.7288C7.62233 10.4237 7.12767 10.4237 6.82257 10.7288C6.51748 11.0339 6.51748 11.5286 6.82257 11.8337L9.16632 14.1774C9.32871 14.3398 9.55432 14.4225 9.78319 14.4036C10.0121 14.3846 10.221 14.266 10.3545 14.0791L14.2607 8.61034Z"
                :fill="color" 
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgCheck',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>